import { AiFillCaretRight } from "react-icons/ai";
import Submemu from "../Submenu/Submemu";
import "./MenuItem.scss";

const MenuItem = (props) => {


  console.log(props.submenu, "propspropspropspropsprops")
  return (
    <>
      {" "}
      <li className="menuitem">{props.text}</li>
      {props.submenu && props.submenu.length > 0 ? <AiFillCaretRight className="righticon" /> : ""}
      {props.submenu && props.submenu.length > 0 ? (
        <div className={"displaysub"} onClick={props.onClick}>
          <Submemu content={props.submenu} />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default MenuItem;
